import React from 'react';
import { Typography, makeStyles, TextLink} from '@ellucian/react-design-system/core';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(() => ({
    copyright: {
        textAlign: 'center', 
    },
    root: {
        paddingTop: spacing40
    },

    privacyPolicy: {
        textAlign: 'center',
        marginBottom: spacing40,
    }

}));

const Footer = () => {
    const classes = useStyles();
    return (
        <div className={classes.root} role="contentinfo">
            <Typography className={classes.copyright}>
                <HtmlFormattedMessage descriptor={{ id: 'footerText' }} />
            </Typography>
                
            <div className = {classes.privacyPolicy} >
                <TextLink
                    id="privacy-policy"
                    variant = "inherit"
                    target="_blank"
                    href="https://www.ellucian.com/privacy"
                >
                    <Typography>
                        <FormattedMessage id="ellucianPrivacyPolicyLinkText" />
                    </Typography>
                </TextLink>
            </div>
        </div>
    );
};

export default Footer;